var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFixedPriceDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-236 -805)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(19 756)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(221 50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.479,4.875h-.812V3.792a3.792,3.792,0,0,0-7.583,0V4.875h-.812A.271.271,0,0,0,64,5.146v6.771A1.084,1.084,0,0,0,65.083,13h7.583a1.084,1.084,0,0,0,1.083-1.083V5.146A.271.271,0,0,0,73.479,4.875Zm-3.793,5.658a.271.271,0,0,1-.269.3H68.333a.271.271,0,0,1-.269-.3L68.235,9a1.072,1.072,0,0,1-.443-.871,1.083,1.083,0,0,1,2.167,0A1.071,1.071,0,0,1,69.515,9Zm1.356-5.658H66.708V3.792a2.167,2.167,0,1,1,4.333,0Z",
    transform: "translate(-64)",
    fill: "#d2d5da"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFixedPriceDisabled);
export default __webpack_public_path__ + "static/media/fixed-price-disabled.2f3dc513f05a86c1807f962d4daa6f3a.svg";
export { ForwardRef as ReactComponent };